import { useState } from 'react';

import { useGoBack } from 'hooks/useGoBack';
import { useRecordModal } from 'hooks/useRecordModal';
import { PresetsDeleteDialog } from 'pages/Presets/components/PresetsDeleteDialog';
import { PresetsEditGeneralDialog } from 'pages/Presets/components/PresetsEditGeneralDialog';
import { useShowController } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Tab } from 'shared/mui/Tab/Tab';
import { TabPanel } from 'shared/mui/TabPanel/TabPanel';
import { Tabs } from 'shared/mui/Tabs/Tabs';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { Preset } from 'types/embedded/preset';

import { PresetsShowActions } from './PresetsShowActions';
import { PresetsShowGeneralTab } from './PresetsShowGeneralTab';
import { PresetsShowGrid } from './PresetsShowGrid';

export const PresetsShow: React.FC = () => {
  const { record } = useShowController<Preset>();
  const { goBack } = useGoBack();
  const deleteModal = useRecordModal();
  const editGeneralModal = useRecordModal();

  const [tab, setTab] = useState(0);

  const paymentItems = record?.paymentItems ?? [];
  const payoutItems = record?.payoutItems ?? [];

  return (
    <ShowPage
      listName="Пресеты"
      rightActionsSlot={
        <PresetsShowActions
          onDelete={deleteModal.handleOpenRecordModal}
          onEditGeneral={editGeneralModal.handleOpenRecordModal}
          record={record}
          tab={tab}
        />
      }
      title="Просмотр пресетов"
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '24px' }}>
        <Tabs onChange={(_, v) => setTab(v)} value={tab}>
          <Tab label="Общая информация" value={0} />
          <Tab label={`Пресеты пополнения (${paymentItems.length})`} value={1} />
          <Tab label={`Пресеты выводов (${payoutItems.length})`} value={2} />
        </Tabs>
      </Box>

      <TabPanel index={0} value={tab}>
        <PresetsShowGeneralTab />
      </TabPanel>

      <TabPanel index={1} value={tab}>
        <PresetsShowGrid items={paymentItems} />
      </TabPanel>

      <TabPanel index={2} value={tab}>
        <PresetsShowGrid items={payoutItems} />
      </TabPanel>

      {deleteModal.openRecordModal && (
        <PresetsDeleteDialog
          onClose={deleteModal.handleCloseRecordModal}
          onSuccess={goBack}
          open={deleteModal.openRecordModal}
          record={record}
        />
      )}
      {editGeneralModal.openRecordModal && record && (
        <PresetsEditGeneralDialog
          onClose={editGeneralModal.handleCloseRecordModal}
          open={editGeneralModal.openRecordModal}
          record={record}
        />
      )}
    </ShowPage>
  );
};
